import React, { useMemo } from 'react';
import { Divider } from 'antd';
import { useEffect, useState } from 'react';
import { useLocation } from 'umi';
import request from '@/utils/request';
import webStorage from '@/utils/storageManager';
import { TICKET_CHANGE_ORDER_STATUS_INIT } from '@/constants';
import IndexStyles from './indexStyles';

export default () => {
  const location = useLocation();
  const { query } = location;
  const { id } = query;
  const [orderDetail, setOrderDetail] = useState({});
  const [orderLeftDetail, setOrderLeftDetail] = useState([]);
  const [orderRightDetail, setOrderRightDetail] = useState([]);
  const { TICKET_CHANGE_ORDER_STATUS } = webStorage.get('DICTOBJ') || {};
  const orderStatusList = [
    {
      value: 'CREATED',
      label: '已下单',
    },
    {
      value: 'PAID',
      label: '已付款',
    },
    {
      value: 'TICKET_ISSUED',
      label: '已出票',
    },
    {
      value: 'COMPLETED',
      label: '已完成',
    },
    {
      value: 'FAILED',
      label: '出票失败',
    },
    {
      value: 'CANCELED',
      label: '已取消',
    },
    {
      value: 'REFUNDING',
      label: '退票中',
    },
    {
      value: 'REFUNDED_AMOUNT',
      label: '已退款',
    },
    {
      value: 'CLOSED',
      label: '已关闭',
    },
  ];
  const labelKeyMap = new Map([
    ['phone', '手机号'],
    ['orderStatus', '订单状态'],
    ['changeStatus', '改签状态'],
    ['priceName', '价格名称'],
    ['payAmount', '实付金额'],
    ['discount', '折扣金额'],
    ['orderNo', '订单号'],
    ['vxNum', '微信交易号'],
    ['thirdOrderNo', '第三方订单号'],
    ['ticketName', '票池'],
    ['priceType', '是否为学生票'],
  ]);

  const changeStatusList = useMemo(() => {
    return (
      TICKET_CHANGE_ORDER_STATUS?.map((i) => ({
        label: i.nameZh,
        value: i.dictCode,
      })) || TICKET_CHANGE_ORDER_STATUS_INIT
    );
  }, [TICKET_CHANGE_ORDER_STATUS]);
  useEffect(() => {
    if (id) {
      request('/order/v2/queryOrderDetail', {
        method: 'POST',
        data: {
          id,
        },
      }).then((res) => {
        if (res.code === 200 || res.code === 0) {
          // const isStudent = res.data.orderItems?.find(
          //   (item) => item.priceType === 'STUDENT',
          // );
          const leftDetail = {
            phone: res.data.mobile,
            orderStatus: orderStatusList.find(
              (item) => item.value === res.data.orderStatus,
            )?.label,
            changeStatus: changeStatusList.find(
              (item) => res.data.changeStatus === item.value,
            )?.label,
            payAmount: res.data.amountPaid,
            discount: res.data.discount,
            orderNo: res.data.orderNo,
            vxNum: res.data.vxNum,
            thirdOrderNo: res.data.thirdOrderNo,
            priceType: res.data.studentTicket === 'STUDENT' ? '是' : '否',
          };
          const leftDetailList = Object.keys(leftDetail).map((key) => {
            return {
              label: labelKeyMap.get(key),
              value:
                key === 'actualPayment' || key === 'discountAmount'
                  ? `¥${leftDetail[key]}`
                  : leftDetail[key],
              key,
            };
          });
          setOrderLeftDetail(leftDetailList);

          const rightList = res.data.orderItems.map((item) => {
            return {
              ticketNo: item.orderItemNo,
              proName: res.data.proName,
              showDate: item.startTime,
              sessionDate: `${item.featureTime}`,
              subpaid: res.data.amountPaid,
              discount: res.data.discount,
              oldPrice: item.oldPrice,
            };
          });
          setOrderRightDetail(rightList);
          setOrderDetail(res.data);
        }
      });
    }
  }, [id]);
  return (
    <IndexStyles>
      <div className="order-detail-container">
        <div className="repertoire-container-content-left">
          {orderLeftDetail.map((item) => {
            return (
              <div className="order-detail-item" key={item.key}>
                <div
                  className="order-detail-item-label"
                  style={{
                    width: ['orderNo', 'vxNum', 'thirdOrderNo'].includes(
                      item.key,
                    )
                      ? '101px'
                      : 'auto',
                  }}
                >
                  {item.label}
                </div>
                <div
                  className="order-detail-item-value"
                  style={{
                    fontSize: item.key === 'amountTotal' ? '20px' : 'inherit',
                    color: item.key === 'discount' ? '#F5729C' : '#111111',
                    textDecoration:
                      item.key === 'discount' ? 'line-through' : 'none',
                  }}
                >
                  {item.value}
                </div>
              </div>
            );
          })}
        </div>
        <div className="repertoire-container-content-right">
          <div className="right-content">
            <div className="right-ticket-name">{orderDetail?.proName}</div>
            <div className="right-content-item" style={{ marginBottom: '6px' }}>
              <label htmlFor="playTime">演出日期</label>
              <div className="right-content-value">{orderDetail?.showDate}</div>
            </div>
            <div className="right-content-item">
              <label htmlFor="playTime">场次时间</label>
              <div className="right-content-value">
                {orderRightDetail?.[0]?.sessionDate}
              </div>
            </div>

            <Divider
              style={{ margin: '16px 0', borderColor: '#ffffff' }}
              dashed
            />

            {orderRightDetail.map((item, index) => (
              <React.Fragment key={index}>
                <div className="ticket-info-wrap">
                  <div className="right-ticket-info-left">
                    <div className="right-ticket-info-item">
                      <label htmlFor="ticketNo">票号</label>
                      <div className="right-ticket-info-item-value">
                        {item.ticketNo}
                      </div>
                    </div>
                    <div className="right-ticket-info-item">
                      <label htmlFor="ticketNo">标准价</label>
                      <div className="right-ticket-info-item-value">
                        {item.oldPrice}
                      </div>
                    </div>
                  </div>
                  <div className="right-ticket-info-right"></div>
                </div>
                {index !== orderRightDetail.length - 1 && (
                  <Divider
                    style={{ margin: '16px 0', borderColor: '#ffffff' }}
                    dashed
                  />
                )}
              </React.Fragment>
            ))}
          </div>
          {/* {orderRightDetail.map((item, index) => (
            <div className="right-content" key={index}>
              <div className="right-content-item">
                <label htmlFor="ticketNo">票号</label>
                <div className="right-content-value">
                  {item.ticketNo}
                </div>
              </div>
              <Divider
                style={{ margin: '16px 0', borderColor: '#ffffff' }}
                dashed
              />
              <div className="right-ticket-name">
                {item.proName}
              </div>
              <div className="ticket-info-wrap">
                <div className="right-ticket-info-left">
                  <div className="right-ticket-info-item">
                    <label htmlFor="playTime">演出日期</label>
                    <div className="right-ticket-info-item-value">
                      {item.showDate}
                    </div>
                  </div>
                  <div className="right-ticket-info-item">
                    <label htmlFor="playTime">场次时间</label>
                    <div className="right-ticket-info-item-value">
                      {item.sessionDate}
                    </div>
                  </div>
                  <div className="right-ticket-info-item">
                    <label htmlFor="playTime">区域座位</label>
                    <div className="right-ticket-info-item-value">
                      {item.regionName}
                    </div>
                  </div>
                </div>
                <div className="right-ticket-info-right">
                  <div className="actual-payment-label">实付金额</div>
                  <div className="actual-payment-value">
                    <span>¥</span>
                    {item.subpaid}
                  </div>
                  <div className="discount-amount-wrap">
                    <div className="discount-amount-label">折扣金额</div>
                    <div className="discount-amount-value">
                      <span>¥</span>
                      {item.discount}
                    </div>
                  </div>
                </div>
              </div>
              <Divider
                style={{ margin: '16px 0', borderColor: '#ffffff' }}
                dashed
              />
              <div className="set-num-wrap">
                <div className="set-num-label">座位数</div>
                <div className="set-num-value">{item.seatKey}</div>
              </div>
            </div>
          ))} */}
        </div>
      </div>
    </IndexStyles>
  );
};
